import axios from 'axios';
import moment from 'moment';
import 'moment-timezone';
import { generateUUID } from '../../Utils';
import { getToken } from '../../Utils/token';

const configuration = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': [
      'Origin', 'Accept', 'X-Requested-With', 'Content-Type', 'Authorization'
    ],
    'Idempotency-Key': generateUUID()
  }
};

const GN_BLOCK_START = 19 * 60; // 7:00 PM ET = 1140
const GN_BLOCK_END   = 21 * 60; // 9:00 PM ET = 1260

const isGoodnightActive = () => {
  if (document.body.id !== 'tenant-service1') return false;
  const now = moment().tz('America/New_York');
  const mins = now.hours() * 60 + now.minutes();
  return mins >= GN_BLOCK_START && mins < GN_BLOCK_END;
};

const instance = axios.create({ configuration });

instance.interceptors.request.use((config) => {
  if (isGoodnightActive()) {
    return Promise.reject({ isGoodnightBlock: true, message: 'Service temporarily unavailable.' });
  }

  if (config.skipAuth) return config;

  const token = getToken() || null;

  let newHeaders = config.headers;
  if (token) {
    newHeaders = Object.assign({}, newHeaders, { Authorization: `Bearer ${token}` });
  }
  return Object.assign({}, config, { headers: newHeaders });
}, (error) => Promise.reject(error));


const getAxios = () => instance;

export default getAxios;